<template>
  <b-navbar type="" variant="" class="navbar-expand-lg background-primary">
    <router-link v-bind:to="{ name: 'index' }" class="navbar-brand">
      <img src="/static/images/logo.png" class="img-fluid" />
    </router-link>
    <b-navbar-toggle target="navbar-header" class="btn btn-outline-light">
      <i class="fa fa-bars"></i>
    </b-navbar-toggle>

    <b-collapse is-nav id="navbar-header">
      <ul class="navbar-nav">
        <router-link
          v-bind:to="{ name: 'index' }"
          v-bind:tag="'li'"
          class="nav-item"
        >
          <a class="nav-link">Home</a>
        </router-link>
        <!--<li> <a href="http://www.keberhasilan.btagroup.co.id/nilaitopemuda.html" v-bind:tag="'li'" class="nav-item">
                        <a class="nav-link">TO Pemuda</a>
                </a></li>-->
        <!-- Guest -->
        <template v-if="!isAuthenticated">
          <b-nav-item-dropdown no-caret>
            <template slot="button-content">
              Tentang BTA Group
              <!-- <img
                src="@/assets/images/arrow.svg"
                class="mx-2 fa-rotate-270"
                alt="BTA Group"
                style="width: 6px"
              /> -->
            </template>
            <b-dropdown-item href="https://btagroup.co.id/about"
              >Sejarah</b-dropdown-item
            >
            <b-dropdown-item href="https://keberhasilan.btagroup.co.id"
              >Alumni</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <!--<router-link
            v-bind:to="{ name: 'static/about' }"
            v-bind:tag="'li'"
            class="nav-item"
          >
            <a class="nav-link">Tentang BTA Group</a>
          </router-link>
          <li>
            <a
              href="http://www.keberhasilan.btagroup.co.id"
              v-bind:tag="'li'"
              class="nav-item"
            >
              <a class="nav-link">Alumni</a>
            </a>
          </li>
          <router-link
            v-bind:to="{ name: 'product/index' }"
            v-bind:tag="'li'"
            class="nav-item"
            v-bind:class="{ active: this.$route.path.match(/^\/product/) }"
          >
            <a class="nav-link">Informasi Pendaftaran</a>
          </router-link>-->
          <b-nav-item-dropdown no-caret>
            <template slot="button-content">
              Produk
              <!-- <img
                src="@/assets/images/arrow.svg"
                class="mx-2 fa-rotate-270"
                alt="Produk BTA"
                style="width: 6px"
              /> -->
            </template>
            <b-dropdown-item href="https://btagroup.co.id/product"
              >Pendaftaran Online</b-dropdown-item
            >
            <b-dropdown-item href="https://ptn.btagroup.co.id"
              >Daya Tampung PTN</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </template>

        <!-- Logged User -->
        <template v-else>
          <!-- Student -->
          <template v-if="profile.isStudent">
            <router-link
              v-bind:to="{ name: 'account/student/index' }"
              v-bind:tag="'li'"
              class="nav-item"
              v-bind:class="{
                active: this.$route.path.match(/^\/account\/student/),
              }"
            >
              <a class="nav-link">Akademis</a>
            </router-link>
            <router-link
              v-bind:to="{ name: 'material/index' }"
              v-bind:tag="'li'"
              class="nav-item"
              v-bind:class="{ active: this.$route.path.match(/^\/material/) }"
            >
              <a class="nav-link">Materi</a>
            </router-link>
            <!--<template v-if="roleElligibleAccessTO()">-->
            <router-link
              v-bind:to="{ name: 'tryout/index' }"
              v-bind:tag="'li'"
              class="nav-item"
              v-bind:class="{ active: this.$route.path.match(/^\/tryout/) }"
            >
              <a class="nav-link"> Tryout </a>
            </router-link>
            <!--</template>-->
            <b-nav-item-dropdown
              no-caret
              v-bind:class="{
                active: this.$route.path.match(/^\/program-study/),
              }"
              v-if="roleElligibleAccess()"
            >
              <template slot="button-content">
                Info Prodi
                <!-- <img
                  src="@/assets/images/arrow.svg"
                  class="mx-2 fa-rotate-270"
                  alt="Rekomendasi Prodi"
                  style="width: 6px"
                /> -->
              </template>
              <b-dropdown-item
                v-bind:to="{
                  name: 'program-study/index',
                  params: { type: courseCategory.id },
                }"
                class="dropdown-item"
                v-for="courseCategory in courseCategories"
                v-bind:key="courseCategory.id"
              >
                {{ courseCategory.name }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <template v-if="roleElligibleAccessJadwal()">
              <router-link
                v-bind:to="{ name: 'schedule/index' }"
                v-bind:tag="'li'"
                class="nav-item"
              >
                <a class="nav-link">Jadwal</a>
              </router-link>
            </template>
            <!--<router-link v-bind:to="{ name: 'product/index' }" v-bind:tag="'li'" class="nav-item" v-bind:class="{active: this.$route.path.match(/^\/product/)}">
                        	<a class="nav-link">Pendaftaran</a>
                   	</router-link>-->
          </template>

          <!-- Employee -->
          <template v-if="profile.isEmployee">
            <router-link
              v-bind:to="{ name: 'account/employee/index' }"
              v-bind:tag="'li'"
              class="nav-item"
              v-bind:class="{ active: this.$route.path.match(/^\/account/) }"
            >
              <a class="nav-link">Data Diri</a>
            </router-link>
            <router-link v-bind:to="'#'" v-bind:tag="'li'" class="nav-item">
              <a class="nav-link">Kelas</a>
            </router-link>
            <router-link v-bind:to="'#'" v-bind:tag="'li'" class="nav-item">
              <a class="nav-link">Belajar</a>
            </router-link>
            <router-link v-bind:to="'#'" v-bind:tag="'li'" class="nav-item">
              <a class="nav-link">Laporan Pengajar</a>
            </router-link>
          </template>

          <router-link
            v-bind:to="{ name: 'forum/index' }"
            v-bind:tag="'li'"
            class="nav-item"
            v-bind:class="{ active: this.$route.path.match(/^\/forum/) }"
          >
            <a class="nav-link">Forum</a>
          </router-link>
          
          
        </template>

		<router-link
          v-bind:to="{ name: 'article/index' }"
          v-bind:tag="'li'"
          class="nav-item"
        >
          <a class="nav-link">Berita</a>
        </router-link>
        <router-link
          v-bind:to="{ name: 'static/contact' }"
          v-bind:tag="'li'"
          class="nav-item"
        >
          <a class="nav-link">Kontak</a>
        </router-link>
      </ul>
      <form
        id="form-section-login"
        v-if="!isAuthenticated"
        v-on:submit.prevent="login"
        class="ml-md-auto mx-3"
      >
        <div class="row">
          <div class="col-md-4 d-none d-md-block">
            <label class="h4">User ID</label>
          </div>
          <div class="col-md-4 d-none d-md-block">
            <label class="h4">Password</label>
          </div>
          <!--<div class="col-md-3 d-none d-md-block text-right">
                        <router-link v-bind:to="{ name: 'authenticate/forget' }" style="font-size: 0.85rem">
                            Lupa Password?
                        </router-link>
                    </div>-->
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12 form-group">
            <input
              type="text"
              required
              class="form-control form-control-sm"
              v-model="form.username"
              placeholder="User ID BTA"
            />
          </div>
          <div class="col-md-4 col-sm-12 form-group">
            <input
              type="password"
              required
              class="form-control form-control-sm"
              v-model="form.password"
              placeholder="Password"
            />
          </div>
          <div class="col-md-3 col-sm-12 form-group">
            <button
              class="btn btn-header btn-sm pull-right btn-block"
              type="submit"
            >
              Log In
            </button>
          </div>
        </div>
      </form>
      <ul class="navbar-nav dropdown-right ml-auto" v-else>
        <b-nav-item-dropdown right no-caret>
          <template slot="button-content">
            <div class="row">
              <div class="col-auto my-auto pr-0">
                <span class="font-weight-light text-white h4">
                  Selamat Datang,
                </span>
              </div>
              <div class="col my-auto text-truncate pl-1 text-white">
                <router-link
                  v-bind:to="{ name: 'account/index' }"
                  class="h4"
                  style="max-width: 200px"
                >
                  {{ profile.name }}
                  <span
                    v-if="profile.isStudent"
                    class="badge badge-info ml-2"
                    v-b-tooltip.hover
                    title="Forum Credit"
                    >{{ profile.student.remainingVouchers }}</span
                  >
                </router-link>
              </div>
              <div class="col-auto">
                <i class="fa fa-ellipsis-h"></i>
              </div>
            </div>
          </template>
          <b-dropdown-item v-bind:to="{ name: 'account/password' }">
            Change Password
          </b-dropdown-item>
          <b-dropdown-item v-on:click="logout"> Log Out </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Header",
  watch: {
    profile() {
      this.fetchCourseCategory();
    },
  },
  computed: mapState(["profile"]),
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      isAuthenticated: false,
      courseCategories: [],
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch("login", {
          user: this.form,
          requestOptions: { meta: { throwError: false } },
        })
        .then((response) => {
          var data = response.data;
          if (data.status) {
            this.isAuthenticated = true;

						// --- MULAI BAGIAN BARU (LOGIKA REDIRECT) ---
            
            // --- LOGIKA REDIRECT SETELAH LOGIN ---
            const pendingRedirect = localStorage.getItem('redirectAfterLogin');

            if (pendingRedirect === 'PENDING_SPECIFIC_LINK') {
              // 1. Hapus memori agar tidak looping
              localStorage.removeItem('redirectAfterLogin');
              
              // 2. AMBIL DATA SISWA SECARA AMAN (Fix disini)
              // Coba ambil dari response login dulu, kalau kosong ambil dari profile store
              let studentData = null;
              
              if (data.data && data.data.student) {
                  studentData = data.data.student;
              } else if (this.profile && this.profile.student) {
                  studentData = this.profile.student; // Fallback ke data profile vuex
              }

              // 3. Cek apakah data siswa & grade ditemukan?
              if (studentData && studentData.btaGrade) {
                  const gradeId = parseInt(studentData.btaGrade.id);
                  let finalUrl = "/account/student/score"; // Default

                  // Logika Penentuan Link
                  if (gradeId === 13) {
                    finalUrl = "/account/student/tryout/1349"; // Kls 8
                  } else if (gradeId === 1) {
                    finalUrl = "/account/student/tryout/1350"; // Kls 9
                  } else if ([2, 4, 5, 6, 7, 8, 9, 57].includes(gradeId)) {
                    finalUrl = "/account/student/tryout/1348"; // SMA/UTBK
                  }

                  // Gunakan replace agar lebih kuat memaksa pindah halaman
                  window.location.replace(finalUrl); 
              } else {
                  // Jika data grade gagal diambil, lempar ke halaman score umum sebagai cadangan
                  window.location.replace("/account/student/score");
              }

            } else {
              // Login biasa tanpa lewat popup
              location.reload();
            }
            
            // --- AKHIR BAGIAN BARU ---

            //                        this.$router.push({name: 'index'});
            //location.reload();
          } else {
            this.form.password = "";
            this.$toastr("warning", data.message, "Warning");
          }
        });
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.isAuthenticated = false;
        this.form = {};
        //                    this.$router.push({name: 'index'});
        window.location.replace(this.$router.resolve({ name: "index" }).href);
      });
    },
    fetchCourseCategory() {
      if (this.profile.isStudent) {
        this.axios
          .get(process.env.API_URL + "/course-category")
          .then((response) => {
            this.courseCategories = response.data.data;
          });
      }
    },
    roleElligibleAccess() {
      return (
        this.profile.isStudent && this.profile.student.btaGrade.level >= 10
      );
    },
    roleElligibleAccessTO() {
      return this.profile.isStudent && this.profile.student.branch.id != 53;
    },
    roleElligibleAccessJadwal() {
      return (
        this.profile.isStudent &&
        this.profile.student.branch.id != 19 &&
        this.profile.student.branch.id != 20 &&
        this.profile.student.branch.id != 22 &&
        this.profile.student.branch.id != 23 &&
        this.profile.student.branch.id != 24 &&
        this.profile.student.branch.id != 25 &&
        this.profile.student.branch.id != 59 &&
        this.profile.student.branch.id != 26
      );
    },
  },
  created() {
    this.isAuthenticated = this.$store.getters.isAuthenticated;
    this.fetchCourseCategory();
  },
};
</script>

<style scoped>
#form-section-login label {
  color: #fff;
}
.btn-header {
  color: #fff;
  background-color: #ed5568;
  border-color: rgb(177, 15, 39);
  border-width: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue